export default __webpack_public_path__ + "static/media/preview.03149c4c.png";